<h1 id="{{data.url}}" class="title">{{data.route}}</h1>
<h3 class="subttitle" *ngIf="data.hasSubtitle" hidden>Subtítulo</h3>
<div class="questions" *ngIf="!data.isQuestion">
    <p class="precontent" *ngIf="data.hasPrecontent"><strong class="redLine">- </strong></p>
    <div class="text-justify" >
      <markdown [data]="data.content"></markdown>
    </div>
    <div *ngIf="data.TypeTable && data.TypeTable.length > 0">
        <div class="tableType" *ngFor="let item of data.TypeTable">
            <p class="underline">{{item.Title}}</p>
            <p class="tableSubtitle">{{item.Subtitle}}</p>
            <div class="contentRows">
                <div class="row contentCells" *ngFor="let rowData of item.TableRow; index as i" [ngClass]="{'headers': i === 0}" >
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-12 attribute1">{{rowData.Attribute1}}</div>
                            <div class="col-4 attribute2">{{rowData.Attribute2}}</div>
                            <div class="col-4 attribute3">{{rowData.Attribute3}}</div>
                            <div class="col-4 attribute4">{{rowData.Attribute4}}</div>
                        </div>
                        
                    </div>
                    <div class="col-md-6 attribute5">
                        <div class="row">
                            <div class="col-12">{{rowData.Attribute5}}</div>
                        </div>
                        
                    </div>
                </div>
            </div>
            <div class="text-justify" *ngIf="item.Textend">
                <markdown [data]="item.Textend"></markdown>
              </div>
        </div>
    </div>
</div>

<div class="questions" *ngIf="data.isQuestion">
    <div class="questionContent" #answers id="answer{{question.id + 1}}" *ngFor="let question of data.questions">
        <p class="precontent"><strong class="redLine">- </strong>{{question.question}}</p>
        <p class="content">{{question.answer}}</p>
    </div>
</div>

